export default __webpack_public_path__ + "3a3ee45101dee04270f51f39b05dc213.png";